import { Grid, Typography } from "@mui/material";
import TextFieldInput from "components/input/textField";
import { useTranslation } from "utils/locales/utilityFunctions";

type Props = {
  customerReq: string;
  inputDisabled: boolean;
  setCustomerReq: (value: string) => void;
};

const SpecialConditionsSection = ({ customerReq, inputDisabled, setCustomerReq }: Props) => {
  const { translate } = useTranslation();

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: -1 }}>
          {translate("biomass-project-form-special-conditions")}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography color="secondary" sx={{ mb: 1 }}>
          {translate("biomass-project-form-customer-requirements")}
        </Typography>

        <TextFieldInput
          title={translate("biomass-project-form-customer-requirements-label")}
          value={customerReq}
          showTitle={false}
          showLabel={true}
          handleChange={(e) => setCustomerReq(e.target.value)}
          disabled={inputDisabled}
          fullWidth
        />
      </Grid>
    </>
  );
};

export default SpecialConditionsSection;
